/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';

// Object.hasOwn (ES2022) has no fallback in Safari/WebKit before 15.4 (iOS <15.4), and
// @inertiajs/core/vue3 ^3.6.1 now depend on es-toolkit, which calls it unconditionally —
// crashing Inertia navigation for every visitor on an older WebKit-based browser. Must run
// before app.js's own `@inertiajs/vue3` import, which is why it's here at the top of bootstrap.js
// (the first import in app.js) rather than in app.js itself.
if (typeof Object.hasOwn !== 'function') {
    Object.hasOwn = (target, key) => Object.prototype.hasOwnProperty.call(target, key);
}
// import './echo';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */
// Load Pusher and Echo asynchronously
// (function loadEcho() {
//     import('pusher-js').then(module => {
//         // console.log('pusher-result', pusher)
//         window.Pusher = module.default;
//         import('laravel-echo').then(module => {
//             // console.log('echo-result', module)
//             const Echo = module.default;
//             window.Echo = new Echo({
//                 broadcaster: 'reverb',
//                 key: import.meta.env.VITE_REVERB_APP_KEY,
//                 wsHost: import.meta.env.VITE_REVERB_HOST,
//                 wsPort: import.meta.env.VITE_REVERB_PORT,
//                 wssPort: import.meta.env.VITE_REVERB_PORT,
//                 forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
//                 enabledTransports: ['ws', 'wss'],
//             });
//             // console.log('window.Echo', window.Echo)
//         })
//     })
// })()

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
